import React, { useState } from 'react';
import { Portal, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const CopyToClipboard = ({ text, children, className, style }) => {
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackMessage, setSnackMessage] = useState('');

    const handleCopy = () => {
        const textToCopy = text || (typeof children === 'string' ? children : children?.props?.children);
        if (!textToCopy) return;

        const textarea = document.createElement('textarea');
        textarea.innerText = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();

        setSnackMessage('Copied to clipboard!');
        setSnackOpen(true);
    };

    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackOpen(false);
    };

    return (
        <>
            <p
                onClick={handleCopy}
                className={className}
                style={{ cursor: 'pointer', ...style }}

            >
                {children}
            </p>
            <Portal>
                <Snackbar open={snackOpen} autoHideDuration={2000} onClose={handleSnackClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                    <Alert onClose={handleSnackClose} severity="success">
                        {snackMessage}
                    </Alert>
                </Snackbar>
            </Portal>
        </>
    );
};

export default CopyToClipboard;